var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    transform: "matrix(-1 0 0 1 38 0)",
    fill: "nene"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H16C11 9 9 11 9 16V22C9 27 11 29 16 29H22C27 29 29 27 29 22V20",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.04 10.02L15.16 17.9C14.86 18.2 14.56 18.79 14.5 19.22L14.07 22.23C13.91 23.32 14.68 24.08 15.77 23.93L18.78 23.5C19.2 23.44 19.79 23.14 20.1 22.84L27.98 14.96C29.34 13.6 29.98 12.02 27.98 10.02C25.98 8.02001 24.4 8.66001 23.04 10.02Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.91 11.15C22.58 13.54 24.45 15.41 26.85 16.09",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilCard);
export default __webpack_public_path__ + "static/media/edit-pencil-card.7fc3c285c8a3aee793760fb638a96fdb.svg";
export { ForwardRef as ReactComponent };